import { Application } from "@core/Application"
import { HTTPClient } from "@core/HTTPClient"
import { buildURL, SystemURL } from "./URLCatalog"
import { HTTPClientInterface, HTTPRequest } from "@core/HTTPClientInterface"

export class TokenServices {
    private httpClient: HTTPClientInterface
    constructor(httpClient: HTTPClientInterface = Application.shared().coreDependencies.unauthenticatedHTTPClient) {
        this.httpClient = httpClient
    }

    async refreshToken(oldToken: string): Promise<string> {
        let body = {
            token: oldToken
        }

        let url = buildURL(SystemURL.Demo.postRefreshToken)
        let request = new HTTPRequest()
        request.method = "POST"
        request.url = url
        request.body = body

        let data = await this.httpClient.execute(request)

        return data.result as string
    }
}